namespace Gordic.Adm.WebControls {
    export interface AdmPoznamkyOptions {
        /** SXS */
        sxs: string;
        /** Typ objektu */
        typ_obj: number;
        /** Content */
        cnt: GContent;
    }

    /** Nový audit přístupů */
    export class AdmPoznamkyNew {
        private sxs: string;
        private typ_obj: number;
        private cnt: GContent;
        private panel: JQuery<HTMLElement>;
        //private panelEL: JQuery<HTMLElement>;
        private gnotePanel: Gordic.GNotePanel;
        private poznamkyCount: GObservableObject<any>;

        constructor(options: AdmPoznamkyOptions) {
            //this.panelEL = $.newDiv();
            this.poznamkyCount = new GObservableObject({ value: "0" })
            this.sxs = (options.sxs ?? "").toString();
            this.typ_obj = options.typ_obj;
            this.cnt = options.cnt;
            this.gnotePanel = new Gordic.GNotePanel();
        }

        private createPoznamky() {
            //this.panelEL.empty();
            this.panel.empty();
            if (Gordic.Prefabs.Utils.isEmpty(this.sxs) || Gordic.Prefabs.Utils.isEmpty(this.typ_obj)) {
                var text = $("<div>").text("jres:32000150"); //RC 32000150 : Některý z identifikátorů poznámky není naplněn.
                this.cnt.dialogs.alert("jres:32000149", text); //RC 32000149 : Upozornění
            } else {
                this.gnotePanel.create(this.panel, null, {
                    sxs: this.sxs,
                    typObj: this.typ_obj,
                    count: (count) => {
                        this.poznamkyCount.value = String(count);
                        this.poznamkyCount.update();
                    }
                });
            }
        }

        getSidePanel(): Gordic.Gin.DetailBuilder.GDetailBuilderSbpanelOptionsId {
            return {
                leaf: {
                    caption: "jres:32000144",
                    //badge: this.poznamkyCount
                },
                icon: "fa-sticky-note-o",
                id: "panelPoznamky",
                caption: "jres:32000144",
                side: "right",
                open: (ev, obj) => {
                    //this.panel = $(ev.target)
                    //$(ev.target).append(this.panelEL);
                    this.panel = $(ev.target);
                    this.createPoznamky();
                }
            }
        }
    }
}